import { useTranslation } from "react-i18next";

import { Button } from "@/modules/theme/components/Button/Button";
import { DialogButtonsWrapper } from "@/modules/theme/components/Dialog/components/DialogButtonsWrapper";
import { Dialog } from "@/modules/theme/components/Dialog/Dialog";

type UpdateDialogProps = {
  isUpdateDialogOpen: boolean;
  isUpdating: boolean;
  onClose: () => void;
};

const translationNamespace = "common/ServiceWorkerInitializer";

export const UpdateAppDialog: React.FC<UpdateDialogProps> = ({
  isUpdateDialogOpen,
  isUpdating,
  onClose,
}) => {
  const { t } = useTranslation(translationNamespace);

  return (
    <Dialog
      isOpen={isUpdateDialogOpen || isUpdating}
      onClose={onClose}
      title={t("New app version 🎉")}
      description={t("Update now!")}
    >
      <DialogButtonsWrapper>
        <Button
          onClick={onClose}
          isDisabled={isUpdating}
          isLoading={isUpdating}
        >
          {t("Update")}
        </Button>
      </DialogButtonsWrapper>
    </Dialog>
  );
};
